import classnames from 'classnames';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, palette }) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      '&:before': {
        content: '""',
        display: 'block',
        marginLeft: spacing(2),
        marginRight: spacing(2),
        width: 1,
        height: spacing(4),
        backgroundColor: palette.divider,
      },
    },
    tiny: {
      '&:before': {
        height: spacing(3),
      },
    },
  })
);

const HeaderSeparator = ({ className = '', isTiny = false }) => {
  const classes = useStyles();

  return <div className={classnames(className, classes.root, { [classes.tiny]: isTiny })} />;
};

export default HeaderSeparator;
